import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from "react";
import { getCity, getProvince, postRegister } from "../../service";

const CulinaryCompetition = () => {

  const [_province, _setProvince] = useState([]);
  const [_selectedProvince, _setSelectedProvince] = useState("");
  const [_city, _setCity] = useState([]);
  const [_selectedcity, _setSelectedcity] = useState("");
  const [showTerms, setShowTerms] = useState(false);


  useEffect(() => {
    getProvince().then((data) => {
      if (data) _setProvince(data);
    });
  }, []);

  useEffect(() => {
    if (_selectedProvince) {
      getCity(_selectedProvince).then((data) => {
        if (data) _setCity(data);
      });
    }
  }, [_selectedProvince]);  

  const schema = yup.object({
    name: yup.string().required('Name must be filled in'),
    phone: yup
      .string()
      .matches(/^[0-9]+$/, 'Number only')
      .min(10, 'Min. 10 digit')
      .required('Whatsapp must be filled in'),
    instagram: yup.string().required('Instagram must be filled in'),
    email: yup.string().email('Email is not valid').required('Email must be filled in'),
    province: yup.string().required('Province must be filled in'),
    city: yup.string().required('City must be filled in'),
    school: yup.string().required('School must be filled in'),
    // video: yup
    //   .string()
    //   .url('Link video tidak valid')
    //   .required('Link video wajib diisi'),
    agreement: yup
      .boolean()
      .oneOf([true], 'Anda harus menyetujui syarat dan ketentuan'),
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      phone: "",
      instagram: "",
      email: "",
      province: "",
      city: "",
      school: "",
      agreement: "",
    },       
  });

  useEffect(() => {
    register('province');
    register('city');
  }, [register]);

  const onSubmit = (data) => {

    postRegister(
      data.name,
      data.phone,
      data.instagram,
      data.email,
      data.province,
      data.city,
      data.school,
      data.agreement,
      'PRGM0005'
    )
    .then(result => {
        console.log('API RESULT:', result);
        window.snap.pay(result, {
            onSuccess: function(result){console.log('success');console.log(result);},
            onPending: function(result){console.log('pending');console.log(result);},
            onError: function(result){console.log('error');console.log(result);},            
            onClose: function(){console.log('customer closed the popup without finishing the payment');}
        })
    })
    .catch((err) => {
      console.error('SUBMIT ERROR:', err);
    });    
  };  

  return (
    <div id="main">
      <section className='main-banner'>
        <div className='row text-white'>
            <div className='col-lg-12 d-flex flex-column align-items-center justify-content-center' style={{height: '100%'}}>
                <img src="/assets/img/slide/home/main-banner.png" alt="main banner" className="w-75" />
                <div style={{textAlign: 'center'}}>
                  <h1><strong>IHMS</strong></h1>
                  <h3>Culinary Competition 2026</h3>
                </div>
            </div>
        </div>
      </section>
      <main id="main">
        <Container>
          <Row>
            <Col>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-headline text-center">
                  <h2>Form Register</h2>
                </div>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Name</Form.Label>
                  <Form.Control 
                    {...register('name')} 
                    type="text" 
                    placeholder="name..." 
                    isInvalid={!!errors.name} 
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name?.message}
                  </Form.Control.Feedback>                
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Whatsapp Number</Form.Label>
                  <Form.Control 
                    {...register('phone')} 
                    type="text" 
                    placeholder="081xxx" 
                    isInvalid={!!errors.phone} 
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phone?.message}
                  </Form.Control.Feedback>                                
                </Form.Group>      
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Instagram</Form.Label>
                  <Form.Control 
                    {...register('instagram')} 
                    type="text" 
                    placeholder="example..." 
                    isInvalid={!!errors.instagram} 
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.instagram?.message}
                  </Form.Control.Feedback>                 
                </Form.Group>     
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Email</Form.Label>
                  <Form.Control 
                    {...register('email')} 
                    type="text" 
                    placeholder="name@example..." 
                    isInvalid={!!errors.email} 
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email?.message}
                  </Form.Control.Feedback>                  
                </Form.Group>     
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Province</Form.Label>
                  <Form.Select 
                    isInvalid={!!errors.province} 
                    value={_selectedProvince}
                    onChange={(e) => {
                      const value = e.target.value;
                      _setSelectedProvince(value);
                      _setSelectedcity("");
                      _setCity([]);

                      setValue('province', value, { shouldValidate: true });
                      setValue('city', '');
                    }}     
                  >
                    <option value="">Choose province</option>
                    {_province.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.province_name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.province?.message}
                  </Form.Control.Feedback>                  
                </Form.Group>    
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>City</Form.Label>
                  <Form.Select 
                    isInvalid={!!errors.city} 
                    value={_selectedcity}
                    onChange={(e) => {
                      const value = e.target.value;
                      _setSelectedcity(value);
                      setValue('city', value, { shouldValidate: true });
                    }}
                  >
                    <option value="">Choose city</option>
                    {_city.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.kabupaten_name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.city?.message}
                  </Form.Control.Feedback>                 
                </Form.Group>               
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>School</Form.Label>
                  <Form.Control 
                    {...register('school')}
                    type="text" 
                    placeholder="SMA..." 
                    isInvalid={!!errors.school} 
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.school?.message}
                  </Form.Control.Feedback>                 
                </Form.Group>     
                {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Audition Video Link</Form.Label>
                  <Form.Control 
                    {...register('video')}
                    type="text" 
                    placeholder="https://..." 
                    isInvalid={!!errors.video} 
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.video?.message}
                  </Form.Control.Feedback>                 
                </Form.Group>  */}
                <Form.Check
                  className="mb-3"
                  {...register('agreement')}
                  label="I agree to the applicable Terms and Conditions."
                  isInvalid={!!errors.agreement}
                  feedback={errors.agreement?.message}
                  feedbackType="invalid"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowTerms(true);
                  }}
                />   
                <div className="d-grid">
                  <Button variant="primary" type="submit" className="fw-bold btn-custom">
                    Submit
                  </Button> 
                </div>                       
              </Form>

              <Modal
                show={showTerms}
                onHide={() => setShowTerms(false)}
                size="lg"
                centered
                className="text-dark"
              >
                <Modal.Header>
                  <Modal.Title>Syarat dan Ketentuan</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                  <ul>
                    <li>Follow us on Instagram</li>
                    <li>Pay the registration fee in full</li>
                    <li>Willingness to fly to Bali</li>
                  </ul>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    variant="primary"
                    className="w-100 btn-custom"
                    onClick={() => {
                      setValue('agreement', true, { shouldValidate: true });
                      setShowTerms(false);
                    }}
                  >
                    Agree
                  </Button>
                </Modal.Footer>
              </Modal>            
              
            </Col>
          </Row>
          <Row className="pt-4">
            <Row>
              <Col sm="12" md="6">
                <p className="text-center">
                  Calling the next generation of future chefs. IHMS Culinary Competition 2026 
                  invites passionate young talents to create bold and innovative 
                  Nusantara-inspired cuisine, redefining Indonesia’s rich culinary 
                  heritage for the modern world.
                </p>
              </Col>
              <Col sm="12" md="6">
                <p className="fw-bold">Who Can Apply</p>
                <ul>
                  <li>High school students</li>
                  <li>Minimum age: 15 years old</li>
                  <li>Maximum age: 22 years old</li>
                  <li>Passionate about cooking and culinary creativity</li>
                </ul>
              </Col>
            </Row>
            <Col sm="12" className="form-headline">
              <h3>Registration Period :</h3>
              <h1 className="text-effect">20 Feb - 9 Mar 2026</h1>
              <p className="fw-bold">All registered participants will receive:</p>
              <ul>
                <li>An exclusive Workshop & Training Session led by our World Champion Chef</li>
                <li>Certificate of Training</li>
              </ul> 
              <div className="text-center fw-bold border border-light p-1 w-100 rounded">Registration fee : Rp125.000</div>           
            </Col>
          </Row>
          <Row className="pt-4">
            <Col className="form-headline">
              <p className="timeline">Timeline :</p>
              <ul>
                <li><b>March 10th </b>: One Session by International Chef</li>
                <li><b>March 13rd </b>: Submission of Recipe</li>
                <li><b>March 18th </b>: Announcement of the best 16</li>
                <li><b>March 27th </b>: Battle of the best 16</li>
                <li><b>March 28th </b>: The Magnificent 6 Grand Final</li>
              </ul>                   
            </Col>
            <Col>
              <div className="d-flex">
                <img src="" alt="" />
                <p>Competition Round :</p>
                <p>27-28 MAR 2026</p>
                <p>IHMS Culinary Kitchen</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="prize-wrapper">
                <h1 className="text-center">Prize Winner</h1>
                <ul>
                  <li>IDR 155 Million Scholarship at IHMS & Melbourne Polytechnic Australia</li>
                  <li>Price Winner total of Millions Rupiah</li>
                  <li>Exclusive Merchandise from IHMS & Partners </li>
                  <li>Gold , Silver & Bronze Medal</li>
                  <li>Throphy for the winner</li>
                </ul>              
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <p>
                This is more than a competition! it is a stage to showcase your 
                talent, creativity, and vision for the future of Indonesian gastronomy.
              </p>
              <p>
                Register now and be part of the culinary revolution!
              </p>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  )  

}

export default CulinaryCompetition;